import { render, staticRenderFns } from "./AppMessagesWithIcon.vue?vue&type=template&id=a438c614&lang=pug"
import script from "./AppMessagesWithIcon.vue?vue&type=script&lang=js"
export * from "./AppMessagesWithIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports